<template>
  <div class="Home">
    <h1>Welcome</h1>
    <form @submit.prevent="saveData">
      <!-- Input for Database Name -->
      <div>
        <label for="databaseName">Database Name:</label>
        <input v-model="databaseName" type="text" id="databaseName" required />
      </div>

      <!-- Input for Key -->
      <div>
        <label for="key">Key:</label>
        <input v-model="key" type="text" id="key" required />
      </div>

      <!-- Input for bool -->
      <div>
        <label for="bool">Is Active:</label>
        <input v-model="bool" type="checkbox" id="bool" />
      </div>

      <!-- Input for Time Over -->
      <div>
        <label for="timeOver">Time Over:</label>
        <input v-model="timeOver" type="text" id="timeOver" required />
      </div>

      <!-- Submit Button -->
      <button type="submit">Save Data</button>
    </form>

    <!-- Redirect Button -->
    <button @click="redirectToDmll">Milliseconds Conveter</button>
  </div>
</template>

<script>
// Import necessary Firebase functions
import { db, ref, set } from './firebase';

export default {
  name: 'HomePage',
  data() {
    return {
      databaseName: '', // The name of the database (first input)
      key: '',           // The key input (string)
      bool: false,       // The bool checkbox (boolean)
      timeOver: '',      // The timeOver input (string)
    };
  },
  methods: {
    // Method to save data to Firebase
    saveData() {
      // Validate that all required fields are provided
      if (!this.databaseName || !this.key) {
        alert('Please provide Database Name and Key');
        return;
      }

      // Prepare the data to save
      const newData = {
        bool: this.bool,   // The boolean value for bool (isActive)
        key: this.key,     // The key (string)
        timeOver: this.timeOver, // The timeOver (string)
      };

      // Construct the path using the database name and a default path "mod/action/isActivate"
      const dataRef = ref(db, `${this.databaseName}/mod/action/isActivate`);

      // Save the data to Firebase Realtime Database
      set(dataRef, newData)
        .then(() => {
          alert('Data saved successfully!');
          // Clear the form after saving
          this.databaseName = '';
          this.key = ''; // Clear the key input
          this.bool = false;
          this.timeOver = '';
        })
        .catch((error) => {
          console.error('Error saving data:', error);
          alert('Failed to save data.');
        });
    },
    
    // Method to redirect to /dmll page
    redirectToDmll() {
      this.$router.push('/dmll'); // Use this.$router in the Options API to navigate
    },
  },
};
</script>

<style scoped>
.Home {
  text-align: center;
  margin-top: 50px;
}
form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
label {
  font-weight: bold;
}
input {
  padding: 5px;
  margin: 5px;
  width: 200px;
}
button {
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}
button:hover {
  background-color: #45a049;
}
</style>
